import classNames from 'classnames';
import React from 'react';
import { getNid, prefix, WebUI } from "../../wui-core/src/index";
import { AnyObject, ModalFooterProps } from './iModal';

const defaultProps: Partial<ModalFooterProps> = {
    componentClass: 'div' as keyof JSX.IntrinsicElements,
    clsPrefix: `${prefix}-modal-footer`,
};

const ModalFooter: React.FC<ModalFooterProps> = (props) => {
    const {
        componentClass: Component = defaultProps.componentClass as keyof JSX.IntrinsicElements,
        clsPrefix = defaultProps.clsPrefix as string,
        className,
        children,
        onCustomRender,
        ...restProps
    } = props;

    const footerChildren = typeof onCustomRender === 'function' ? onCustomRender(children) : children;

    const classes: AnyObject = {};
    classes[`${clsPrefix}`] = true;
    const adapterNid = getNid(props)

    return (
        <Component
            {...restProps}
            className={classNames(className, classes)}
            {...adapterNid}
        >
            {footerChildren}
        </Component>
    );
};

export default WebUI({name: "modal-footer", defaultProps})(ModalFooter) as React.FC<Partial<ModalFooterProps>>;
